import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-driver-deliveries',
  templateUrl: './driver-deliveries.component.html',
  styleUrls: ['./driver-deliveries.component.scss']
})
export class DriverDeliveriesComponent implements OnInit {

  @Input() driverDeliveries;
  @Output() onDeliveryListClick = new EventEmitter<string>();
  @Input() Status;
  constructor() { }

  ngOnInit(): void {
  }

}
